export class EmptyInstance {
}
